export class EmptyInstance {
}
